import { getHeatmapStyle } from 'map-style-utils'
import { Layer, LayerProps } from 'ms-map-gl'
import { useMemo } from 'react'

import { useLayerFilter } from '~map-preview/hooks/useLayerFilter'

export const HeatmapLayer = () => {
  const { fill } = useMemo(() => getHeatmapStyle(), [])
  const filter = useLayerFilter()

  return (
    <Layer
      {...(fill as LayerProps)}
      {...(filter as object)}
    />
  )
}
